import React from 'react';
import styled from '@emotion/styled';
import { MegaMenuCSSCustomProperties, fadeTransitions } from './MegaMenu.config';
import { createCSSPropertyTransition } from '@polestar/component-warehouse-react/tokens/motion/Motion';
import { createCustomSpacing } from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
import { useDirection } from '@polestar/component-warehouse-react/contexts/direction';
export const MegaMenuVisuals = ({ visuals }) => {
    const { light, dark } = visuals.theme;
    const { isRTL } = useDirection();
    return (React.createElement(Container, null,
        React.createElement(LightVisual, null,
            React.createElement(Image, { src: light.src, srcSet: `${light.src}?w=535, ${light.src}?w=535&dpr=2 2x`, alt: "", role: "presentation", isRTL: isRTL })),
        React.createElement(DarkVisual, null,
            React.createElement(Image, { src: dark.src, srcSet: `${dark.src}?w=535, ${dark.src}?w=535&dpr=2 2x`, alt: "", role: "presentation", isRTL: isRTL }))));
};
const Container = styled.div `
  display: grid;
  inline-size: 100%;
  block-size: 100%;
  margin-inside: auto 0;

  > * {
    grid-area: 1 / 1;
  }
`;
const Visual = styled.picture `
  inline-size: min(100%, ${createCustomSpacing(535 / 16)});
  display: block;
  transition: ${createCSSPropertyTransition('opacity', fadeTransitions)};
  margin-inline: auto 0;
`;
const Image = styled.img `
  inline-size: 100%;
  block-size: 100%;
  object-fit: contain;
  object-position: 100% 100%;
  translate: ${({ isRTL }) => (isRTL ? '0' : '4%')} calc(4% - ${createCustomSpacing(10 / 16)});
`;
const LightVisual = styled(Visual) `
  opacity: calc(0 + var(${MegaMenuCSSCustomProperties.isLightTheme}, 1));
`;
const DarkVisual = styled(Visual) `
  opacity: calc(1 - var(${MegaMenuCSSCustomProperties.isLightTheme}, 1));
`;
